/* eslint-env browser */
import _ from 'lodash';

import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';

import SharedConfig from 'shared/config';
import { tagByKey } from 'shared/itemTags';

import { selectors as localeSelectors } from 'frontend/state/reducers/locale';
import { isBetaSite } from 'frontend/util';

import config from 'frontend/config';

export const sizeMap = {
  small: 18,
  medium: 36,
  large: 56,
};

export const itemBadge = item => {
  const badge = {
    text: null,
    title: null,
    size: 12,
    color: config.colors.darkblue,
  };

  const tags = [];
  _.each(item.tags, tagKey => {
    if (tagByKey[tagKey]?.badge) {
      tags.push(tagByKey[tagKey]);
    }
  });
  if (_.size(tags)) {
    badge.text = _.first(tags).shortName;
    badge.title = _.join(_.map(tags, 'name'), ' & ');
    badge.color = _.first(tags).color;
    if (_.size(tags) > 1) {
      badge.text += '*';
    }
  } else if (item.customItem) {
    const tag = tagByKey['custom-item'];
    badge.text = tag.shortName;
    badge.title = tag.name;
    badge.color = tag.color;
    badge.size = 11;
  }

  let result = null;
  if (badge.text) {
    result = badge;
  }

  return result;
};

const styles = {
  dull: {
    opacity: 0.4,
    filter: 'grayscale(25%)',
  },
  highlight: {
    backgroundColor: config.colors.orange,
  },
};

const HIDE_GEM_ITEM_IDS = [
  167555,
];

class WowIcon extends React.Component {
  static propTypes = {
    icon: PropTypes.string,
    alt: PropTypes.string,
    size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    type: PropTypes.string,
    quality: PropTypes.number,
    source: PropTypes.string,
    extra: PropTypes.shape({
      bonus: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
      ench: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
      gems: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
      setPieces: PropTypes.array,
    }),
    dull: PropTypes.bool,
    highlight: PropTypes.bool,
    border: PropTypes.string,
    borderStyle: PropTypes.string,
    noLink: PropTypes.bool,
    locale: PropTypes.string,
    subscript: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    craftingQuality: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    hideCraftingQuality: PropTypes.bool,
  };

  static defaultProps = {
    alt: '',
    size: 'medium',
    icon: null,
    id: null,
    type: null,
    quality: null,
    source: 'wowhead',
    extra: null,
    dull: false,
    highlight: false,
    border: '',
    borderStyle: 'solid',
    noLink: false,
    locale: null,
    subscript: null,
    craftingQuality: null,
    hideCraftingQuality: false,
  };

  componentDidMount() {
    if (this.linkNode && window.CurseTips) {
      window.CurseTips['wowdb-tooltip'].watchElements(this.linkNode);
    }
  }

  componentDidUpdate() {
    if (this.linkNode && window.CurseTips) {
      window.CurseTips['wowdb-tooltip'].watchElements(this.linkNode);
    }
  }

  render() {
    const {
      icon,
      alt = '',
      size,
      id,
      type,
      quality,
      source,
      extra,
      dull,
      highlight,
      border,
      borderStyle,
      noLink,
      locale,
      subscript,
      craftingQuality,
      hideCraftingQuality,
    } = this.props;

    let sizePx;
    let sourceSize;
    if (sizeMap[size]) {
      sizePx = sizeMap[size];
      sourceSize = sizePx;
    } else if (_.isInteger(size)) {
      sizePx = size;
      sourceSize = sizeMap.large;
    } else {
      sourceSize = sizeMap.medium;
      sizePx = sourceSize;
    }
    let url;
    if (icon) {
      url = `https://www.raidbots.com/static/images/icons/${sourceSize}/${icon || 'inv_misc_questionmark'}.png`;
    } else {
      url = `/icon/${sourceSize}/id/${type}/${id}.png`;
    }
    //const url = `/icon/${sizeMap[size]}/${icon || 'inv_misc_questionmark'}.jpg`;
    let qualityBorder = '';
    if (quality) {
      const borderSize = sizePx < sizeMap.medium ? 1 : 2;
      qualityBorder = `${borderSize}px ${borderStyle} ${config.colors.items[quality]}`;
    }
    let result = (
      <img
        src={url}
        alt={alt}
        width={sizePx}
        height={sizePx}
        style={{
          width: sizePx,
          height: sizePx,
          border: border || qualityBorder,
        }}
      />
    );

    let onClick = () => {};
    if (noLink) {
      onClick = e => {
        if (noLink) {
          e.preventDefault();
        }
      };
    }
    if (id && type) {
      // allow referrer for wowhead
      let rel = 'noopener';

      if (source === 'wowhead') {
        let wowheadData = '';
        let wowheadExtra = {};
        if (extra) {
          wowheadExtra = { ...extra };
          wowheadExtra.pcs = _.replace(wowheadExtra.setPieces, /,/g, ':');
          wowheadExtra.setPieces = undefined;
          if (!_.includes(HIDE_GEM_ITEM_IDS, id)) {
            wowheadExtra.gems = _.replace(wowheadExtra.gems, /,/g, ':');
          }
        }
        if (craftingQuality) {
          wowheadExtra['crafting-quality'] = parseInt(craftingQuality, 10) + 3;
        }
        wowheadData = _.map(_.pickBy(wowheadExtra), (val, key) => `${key}=${val}`).join('&');

        const localeMap = {
          en_US: 'www',
          de_DE: 'de',
          es_ES: 'es',
          fr_FR: 'fr',
          it_IT: 'it',
          pt_BR: 'pt',
          ru_RU: 'ru',
          // ko
          // cn
        };
        if (isBetaSite()) {
          const testEnvInfo = _.find(SharedConfig.wowEnvs, { key: SharedConfig.wowEnvMap.test });
          localeMap.en_US = testEnvInfo.wowheadSubdomain;
        }
        const subdomain = localeMap[locale] || 'www';
        const wowheadUrl = `//${subdomain}.wowhead.com/${type}=${id}?${wowheadData}`;
        result = (
          // eslint-disable-next-line react/jsx-no-target-blank
          <a
            href={wowheadUrl}
            rel={rel}
            data-wowhead={wowheadData}
            // this is handled above
            // eslint-disable-next-line react/jsx-no-target-blank
            target="_blank"
            onClick={onClick}
            style={{
              display: 'block',
              width: sizePx,
              height: sizePx,
            }}
          >
            {result}
          </a>
        );
      } else if (source === 'wowdb') {
        if (extra) {
          const keyMap = {
            bonus: 'bonusIDs',
            ench: 'enchantment',
            gems: 'gems',
            setPieces: 'setPieces',
            ilvl: 'itemLevelOverride',
          };
          const bonusIds = extra.bonus;
          if (bonusIds && _.isString(bonusIds)) {
            extra.bonus = bonusIds.replace(/:/g, ',');
          }
          rel = _.map(_.pickBy(extra), (val, key) => `${keyMap[key]}=${val}`).join('&');
        }
        const typeMap = {
          spell: 'spells',
          item: 'items',
        };
        let wowdbUrl = `//www.wowdb.com/${typeMap[type]}/${id}`;
        if (rel) {
          wowdbUrl += `?${rel}`;
        }
        result = (
          <a
            href={wowdbUrl}
            rel="noopener noreferrer"
            // allow referrer for wowdb
            // eslint-disable-next-line
            target="_blank"
            ref={link => { this.linkNode = link; }}
            onClick={onClick}
          >
            {result}
          </a>
        );
      }
    }
    let craftingQualityOverlay;
    if (craftingQuality && !hideCraftingQuality) {
      const qualityIcon = `/images/crafting-quality-${craftingQuality}.png`;
      const scale = _.min([sizePx / 30, 1]);
      const qualSize = 30 * scale;
      craftingQualityOverlay = (
        <div
          style={{
            position: 'absolute',
            top: -5 * scale,
            left: -5 * scale,
            pointerEvents: 'none',
            height: qualSize,
          }}
        >
          <img src={qualityIcon} width={qualSize} height={qualSize} alt={`Crafting Quality ${craftingQuality}`} />
        </div>
      );
    }

    let subscriptEl;
    if (subscript) {
      subscriptEl = (
        <div
          style={{
            fontFamily: 'Tahoma',
            fontSize: sizePx * 0.4,
            position: 'absolute',
            bottom: 0,
            right: 0,
            background: 'rgba(0, 0, 0, 0.9)',
            padding: '1px 0px 0px 1px',
            margin: 0,
            lineHeight: 1,
            pointerEvents: 'none',
          }}
        >
          {subscript}
        </div>
      );
    }
    let style;
    if (dull) {
      style = styles.dull;
    } else if (highlight) {
      style = styles.highlight;
    }

    const final = (
      <div
        key={`icon-${type}-${id}`}
        style={{
          ...style,
          position: 'relative',
          lineHeight: 1,
          height: sizePx,
        }}
      >
        {result}
        {subscriptEl}
        {craftingQualityOverlay}
      </div>
    );
    return final;
  }
}

const mapStateToProps = state => ({
  source: 'wowhead',
  locale: localeSelectors.locale(state).locale,
});

export default connect(mapStateToProps)(WowIcon);
